import React, { useState, useEffect, useCallback } from "react";
import "./Dashboard.css";
import LeftPanel from "../components/leftPanel";
import RightPanel from "../components/rightPanel";
import { Helmet } from "react-helmet-async";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactGA from "react-ga4";
import { analytics } from "../components/firebase";
import { getAnalytics, logEvent } from "firebase/analytics";
import { config } from "../config";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const googleanalytics = process.env.REACT_APP_GOOGLE_ANALYITCS_ID;
  const navigate = useNavigate();

  React.useEffect(() => {
    document.documentElement.style.setProperty("--main-color", config.color);
  }, [config.color]);
  
  
  const initializeGA = () => {
    const id = process.env.REACT_APP_GOOGLE_ANALYITCS_ID;
    if (id) {
      ReactGA.initialize(id);
    }
  };

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const getCookie = (name) => {
    const nameEq = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEq) === 0) return c.substring(nameEq.length, c.length);
    }
    return "";
  };

  const handleRedirect = useCallback(async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const subscriptionId = urlParams.get("subscription_id");
    const status = urlParams.get("status");

    if (!subscriptionId || !status) {
      return;
    }

    try {
      const response = await fetch(
        `${config.baseURL}/save_dodo_subscription.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include", 
          body: JSON.stringify({
            subscription_id: subscriptionId,
            status: status,
          }),
        }
      );

      const result = await response.json();

      if (
        response.status === 200 &&
        result.success &&
        result.subscription_status.toLowerCase() !== "failed"
      ) {
        localStorage.setItem(
          "subscriptionStatus",
          JSON.stringify(result.subscription_status.toUpperCase())
        );
        localStorage.setItem("planId", JSON.stringify(result.plan_id));

        toast(
          "You have successfully subscribed to the plan! Enjoy your benefits!",
          {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );

        const currentUrl = window.location.href;
        const newUrl = currentUrl.split("?")[0];
        window.history.replaceState({}, "", newUrl);

        if (analytics) logEvent(analytics, "Subscription_Success");
        if (googleanalytics)
          ReactGA.event({
            category: "Subscription",
            action: "Success",
            label: `Status: ${result.subscription_status}`,
          });
      } else {
        toast("Subscription failed. Please try again.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        if (analytics) logEvent(analytics, "Subscription_Failed");
        if (googleanalytics)
          ReactGA.event({
            category: "Subscription",
            action: "Failed",
          });
      }
    } catch (error) {
      toast("Subscription failed. Please try again.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      if (analytics) logEvent(analytics, "Subscription_Failed");
      if (googleanalytics)
        ReactGA.event({
          category: "Subscription",
          action: "Failed",
        });
    }
  }, []);

  useEffect(() => {
    handleRedirect();
  }, [handleRedirect]);

  return (
    <>
      <Helmet key="dashboard">
        <title>Ai Legal Document Generator</title>

        <meta
          name="description"
          content="LegalDocumentGenerator.com is your one-stop solution for fast, reliable, and customizable legal documents. Whether you need contracts, agreements, wills, NDAs, or business-related forms, we’ve got it covered. Our AI-powered platform ensures legally accurate and professionally formatted documents tailored to your specific needs. What We Offer: ✅ All Legal Document Types: Contracts, Leases, Wills, Business Agreements, and more. ✅ Customizable Templates: Fill in your details and generate instantly. ✅ AI-Assisted Drafting: No legal jargon—just easy-to-understand forms. ✅ Lawyer-Approved: Ensuring compliance with legal standards. ✅ Safe & Secure: Your data is encrypted and protected. Why Choose Us? 🚀 Fast Generation – Get your legal documents in just a few clicks. 🔒 Affordable – Pay per document or choose from subscription plans. 📋 Always Updated – We stay current with the latest legal standards."
        />
        <meta
          name="keywords"
          content="generate legal documents online, legal document generator, create legal documents online, AI legal document templates, customizable legal forms, online contract generator, NDA template generator, lease agreement creator, will and testament generator, legal paperwork automation, document management software online, business form templates, instant legal form creation, legal compliance templates, business agreement template, employment contract template, AI-powered legal document automation, contract review software, no-code legal workflows, regulatory compliance solutions, legal analytics tools, data privacy agreements, automated contract management, collaborative legal billing, document management systems for law firms, cybersecurity legal solutions"
        />
        <link
          rel="canonical"
          href="https://legaldocumentgenerator.com/dashboard"
        />
      </Helmet>

      <div className="hamburger-custom-wrapper">
        <Header />
      </div>
      <div className="App">
        <LeftPanel className="LeftPanel" />
        <RightPanel className="RightPanel" />

        <ToastContainer />
      </div>
    </>
  );
}

export default App;
